import { EventRow } from './logger.event-row';
import { loggerConstants } from './logger.constants';
import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';

export class PerformanceEvent extends EventRow {
    constructor(
        component: string,
        operation: string,
        time?: number,
        count?: string,
        concept?: string,
        details?: object
    ) {
        super(loggerConstants.Event_Performance);
        this.addToProperties('component', component);
        this.addToProperties('operation', operation);
        this.addToProperties('timeTaken', time ? time.toString() : '');
        this.addToProperties('totalCount', count || '');
        this.addToProperties('concept', concept || '');
        if (details) {
            this.addToProperties('details', JSON.stringify(details));
        }
    }

    public generateLoggingEntry(): IExtendedTelemetryItem {
        return {
            name: loggerConstants.Event_Performance,
            data: { eventName: this.eventName, ...this.getStringifiedProperties(), ...this.measurements }
        };
    }
}
